import { makeAppDisplayDetails, makeMarketplaceAppDisplayDetails } from '@atlassian/mpac-spi';
import { Option } from 'funfix-core';
import { List, Record } from 'immutable';
export const makeInstallInstructionsStep = Record({
  image: undefined,
  bodyHTML: ''
});
export const makeInstructionalApp = Record({
  details: makeMarketplaceAppDisplayDetails(makeAppDisplayDetails()),
  learnMoreLink: Option.empty(),
  steps: List()
});